<template>
  <v-card v-if="vehicle && vehicle.vehicleDetail">
    <v-btn color="grey" small class="tariff-left-headers">
      <h3>{{ $i18n.t("Tyres") }}</h3>
    </v-btn>
    <v-btn
      color="blue"
      x-small
      class="tariff-right-headers"
      style="float: right"
      @click="vehicle.vehicleDetail.tyres.push({})"
      >{{ $i18n.t("Add") }}</v-btn
    >
    <v-row style="padding: 10px 10px">
      <v-simple-table style="width: 100%; margin: 10px">
        <thead>
          <tr>
            <th class="primary--text">{{ $i18n.t("#") }}</th>
            <th class="primary--text">
              {{ $i18n.t("Make") }}/{{ $i18n.t("Model") }}
            </th>
            <th class="primary--text">{{ $i18n.t("Position") }}</th>
            <th class="primary--text">
              {{ $i18n.t("Purchase Date") }}/{{ $i18n.t("Code") }}
            </th>
            <th class="primary--text">
              {{ $i18n.t("Price") }}/{{ $i18n.t("Bill") }}
            </th>
            <th class="text-right primary--text">{{ $i18n.t("Action") }}</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(tyre, index) in vehicle.vehicleDetail.tyres" :key="index">
            <td>{{ index + 1 }}</td>
            <td>
              <v-text-field
                :label="$i18n.t('Make')"
                v-model="tyre.make"
              ></v-text-field>
              <br />
              <v-text-field
                :label="$i18n.t('Model')"
                v-model="tyre.model"
              ></v-text-field>
              <br />
              <v-text-field
                :label="$i18n.t('KM')"
                v-model="tyre.km"
                type="number"
              ></v-text-field>
            </td>
            <td>
              <v-select
                :label="$i18n.t('Row')"
                :items="[
                  { name: 1, value: 1 },
                  { name: 2, value: 2 },
                  { name: 3, value: 3 },
                  { name: 4, value: 4 },
                  { name: 5, value: 5 },
                  { name: 6, value: 6 },
                  { name: 7, value: 7 },
                ]"
                v-model="tyre.rowType"
                item-text="name"
                item-value="value"
              ></v-select>
              <br />
              <v-switch
                v-model="tyre.isLeft"
                :label="$i18n.t(tyre.isLeft ? 'Left Side' : 'Right Side')"
              ></v-switch>
              <br />
              <v-switch
                v-model="tyre.isInner"
                :label="
                  $i18n.t(tyre.isInner ? 'Inner Position' : 'Outer Position')
                "
              ></v-switch>
            </td>
            <td>
              <z-date-picker
                :label="$i18n.t('Date')"
                v-model="tyre.purchaseDate"
              ></z-date-picker>
              <br />
              <v-text-field
                :label="$i18n.t('Code')"
                v-model="tyre.code"
              ></v-text-field>
              <br />
              <v-text-field
                :label="$i18n.t('Price')"
                v-model="tyre.price"
              ></v-text-field>
            </td>

            <td>
              <v-text-field
                :label="$i18n.t('Bill')"
                v-model="tyre.billNo"
              ></v-text-field>
              <br />
              <z-upload-file-dialog
                v-if="tyre.id != null && tyre.id > -1 && (!tyre.attachment || !tyre.attachment.url)"
                :requestURL="
                  '/api/vehicle/' + vehicle._id + '/tyre/' + tyre.id + '/upload'
                "
                @closeDialog="reload"
                btn
              >
                <v-btn color="blue" x-small>
                  {{ $i18n.t("Upload Bill Document") }}
                </v-btn>
              </z-upload-file-dialog>
              <a :href="tyre.attachment.url" v-if="tyre.attachment && tyre.attachment.url">Download Attachment</a>
              <!-- <br />
              <br />
              <z-confirm-button color="orange" x-small
                message="Save this tyre details as expense ?">
                {{ $i18n.t("Save as Expense") }}
              </z-confirm-button> -->
            </td>
            <td>
              <v-btn
                color="red"
                small
                text
                fab
                @click="remove(vehicle.vehicleDetail.tyres, index)"
              >
                <v-icon>mdi-trash-can-outline</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-row>
  </v-card>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
// import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component({
  name: "Tyre",
  props: {
    value: {
      default: null,
    },
  },
})
export default class Tyre extends Vue {
  vehicle = null;

  get loading() {
    return common.loading;
  }

  reload() {
    this.$emit("reload", true);
  }

  @Watch("value")
  onValueChange(newVal) {
    this.vehicle = newVal;
  }

  async mounted() {
    if (this.value) this.vehicle = this.value;

    if (!this.vehicle) this.vehicle = {};
    if (!this.vehicle.vehicleDetail) this.vehicle.vehicleDetail = {};
    if (!this.vehicle.vehicleDetail.tyres)
      this.vehicle.vehicleDetail.tyres = [];
  }

  addExpenseUrl() {
    return;
  }

  remove(list, _index) {
    list.splice(_index, 1);
  }

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }
}
</script>

<style scoped>
.tariff-left-headers {
  text-transform: none;
  color: #555;
  top: -10px;
  left: 10px;
  right: 0px;
  font-size: 12px;
}
.tariff-right-headers {
  text-transform: none;
  color: #555;
  top: -10px;
  right: 10px;
  font-size: 12px;
}
.close-button {
  text-transform: none;
  color: rgb(255, 66, 66);
  bottom: 7px;
  /* top: -10px; */
  right: 0px;
  font-size: 12px;
  position: absolute;
  z-index: 100;
}
.tab-pane {
  display: none;
}
</style>